import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { subadminService } from "../../services/SubadminServices";

const SubAdminList = () => {
  const [subadmins, setSubadmins] = useState([]);
  const [filteredSubadmins, setFilteredSubadmins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchSubadmins();
  }, []);

  useEffect(() => {
    const filtered = subadmins.filter((subadmin) =>
      [subadmin.fullName, subadmin.email, subadmin.phoneNumber]
        .join(" ")
        .toLowerCase()
        .includes(search.toLowerCase())
    );
    setFilteredSubadmins(filtered);
  }, [search, subadmins]);

  const fetchSubadmins = async () => {
    try {
      const response = await subadminService.getSubadminList();
      if (response.status === 200 && response.data && Array.isArray(response.data.data)) {
        const subadminData = response.data.data.filter(
          (item) => item.role === "subadmin"
        );

        setSubadmins(subadminData);
        setFilteredSubadmins(subadminData);
      } else {
        toast.error(response?.data?.message || "Failed to fetch subadmins.");
      }
    } catch (error) {
      toast.error(error.message || "Failed to fetch subadmins.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this Subadmin?")) {
      try {
        await subadminService.deleteSubadmin(id);
        toast.success("Subadmin deleted successfully.");
        fetchSubadmins();
      } catch (error) {
        toast.error(error.message || "Failed to delete subadmin.");
      }
    }
  };

  const formatPermissions = (permissions) => {
    if (!permissions || typeof permissions !== "object") return "-";
    return Object.keys(permissions)
      .filter((key) => permissions[key])
      .join(", ");
  };

  const columns = [
    {
      name: "Name",
      selector: (row) => row.fullName || "-",
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email || "-",
      sortable: true,
    },
    {
      name: "Phone",
      selector: (row) => row.phoneNumber || "-",
      sortable: true,
    },
    {
      name: "Permissions",
      selector: (row) => formatPermissions(row.permissions),
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) =>
        row.status === "active" ? (
          <span className="badge bg-success">Active</span>
        ) : (
          <span className="badge bg-secondary">Inactive</span>
        ),
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="btn-group" role="group">
          <Link
            to={`/admin/subadmins/edit/${row._id}`}
            className="btn btn-outline-secondary"
          >
            <i className="icofont-edit text-success"></i>
          </Link>
          <button
            onClick={() => handleDelete(row._id)}
            className="btn btn-outline-secondary deleterow"
          >
            <i className="icofont-ui-delete text-danger"></i>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  if (loading) return <p>Loading subadmins...</p>;

  return (
    <div className="body d-flex py-3">
      <div className="container-xxl">
        <div className="row align-items-center">
          <div className="border-0 mb-4">
            <div className="card-header py-3 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap">
              <h3 className="fw-bold mb-0">Subadmin List</h3>
            </div>
          </div>
        </div>
        <div className="row align-item-center">
          <div className="col-md-12">
            <div className="card mb-3">
              <div className="card-header py-3 bg-transparent border-bottom-0">
                <div className="card-header d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap">
                  <h6 className="mb-0 fw-bold">Subadmin Users</h6>
                  <Link
                    to="/admin/subadmins/create"
                    className="btn btn-primary step-btn"
                  >
                    + Add New
                  </Link>
                </div>
              </div>
              <div className="card-body">
                <div className="row mb-3">
                  <div className="col-md-4">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by name, email, or phone"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                </div>
                <DataTable
                  columns={columns}
                  data={filteredSubadmins}
                  pagination
                  highlightOnHover
                  responsive
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubAdminList;
